import React from 'react';
import { useParams } from 'react-router';
import {
  Box,
  Card,
} from '@material-ui/core';

import EmptyState from 'src/components/EmptyState';
import Button from 'src/components/Button';
import useModal from 'src/components/Modal/useModal';
import HttpLedger from 'src/components/HttpLedger';
import getTaskStatusLabel from 'src/utils/getTaskStatusLabel';
import TaskCell from 'src/components/cells/TaskCell';
import AssignedCompletedCell from 'src/components/cells/AssignedCompletedCell';
import Ledger from 'src/components/Ledger';
import EngagementNameCell from 'src/components/cells/EngagementNameCell';
import TaskHandlerModal from 'src/views/shared/TaskHandlerModal';
import { TaskWithDetailedTriggeredAction } from 'src/types';
import Content from 'src/components/Content';
import useGetRequest from 'src/hooks/useGetRequest';

function TasksForWorkflowLedger() {
  const { workflowId } = useParams();
  const { result: workflow, isLoading } = useGetRequest({
    url: `/automatic/workflows/${workflowId}/`,
    initialResult: { steps: [], edges: [] },
  });

  const {
    closeModal,
    modalContent,
    openModal,
  }: {
    closeModal: () => void,
    modalContent?: TaskWithDetailedTriggeredAction,
    openModal: (task: TaskWithDetailedTriggeredAction) => void,
    isOpen: boolean,
  } = useModal();

  if (isLoading) return null;

  const columns = [
    {
      title: 'Task',
      cellContent: (task: TaskWithDetailedTriggeredAction) => <TaskCell task={task} />,
    },
    {
      title: 'Engagement',
      cellContent: (task: TaskWithDetailedTriggeredAction) => (
        <EngagementNameCell engagement={task.engagement} />
      )
    },
    {
      title: 'Status',
      cellContent: (task: TaskWithDetailedTriggeredAction) => (
        <Box>
          {getTaskStatusLabel(task)}
        </Box>
      )
    },
    {
      title: 'Assigned date',
      cellContent: (task: TaskWithDetailedTriggeredAction) => <AssignedCompletedCell task={task} />
    },
    {
      cellContent: (task: TaskWithDetailedTriggeredAction) => (
        <Button onClick={() => openModal(task)} disabled={Boolean(task.completedDatetime)}>
          Complete
        </Button>
      ),
      cellProps: {
        align: 'right',
      },
    },
  ];

  const breadcrumbs = [
    {
      title: 'Workflows',
      route: '/workflows',
    },
    {
      title: workflow.name,
      route: `/workflows/${workflowId}/dashboard`,
    },
  ];

  return (
    <Content title="All tasks" breadcrumbs={breadcrumbs} maxWidth="lg">
      <Card>
        <HttpLedger
          url={`/automatic/workflows/${workflowId}/tasks/`}
          columns={columns}
          emptyState={<EmptyState />}
          isPaginated
          isSearchable
          render={({
            fetchData,
            ...ledgerProps
          }: any) => (
            <>
              {
              modalContent && (
                <TaskHandlerModal
                  task={modalContent}
                  onClose={closeModal}
                  engagementId={modalContent.engagementId.toString()}
                  onSuccess={fetchData}
                />
              )
            }
              <Ledger {...ledgerProps} />
            </>
          )}
        />
      </Card>
    </Content>
  );
}

export default TasksForWorkflowLedger;
